import { GridColDef } from "@mui/x-data-grid";
import DetailButton from "./DetailButton";

export const purchaseColumns: GridColDef[] = [
  {
    field: "",
    renderCell: DetailButton,
    width: 150,
    headerName: "",
    sortable: false,
    filterable: false,
  },
  {
    field: "creatorId",
    headerName: "Oluşturan",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "purchaseToken",
    headerName: "Token",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "orderId",
    headerName: "Sipariş Id",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "productId",
    headerName: "Ürün Id",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "platform",
    headerName: "Platfom",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "isConsumed",
    headerName: "Tüketildi",
    flex: 1,
    minWidth: 80,
    type: "boolean",
  },
  {
    field: "creationTime",
    headerName: "Oluşturma Tarihi",
    type: "dateTime",
    flex: 1,
    minWidth: 80,
    valueGetter: (v, r) => new Date(v),
  },
];
